export default "__VITE_ASSET__8fa34f31__"